import { render } from "./z-screen.vue?vue&type=template&id=cb0e7f9e&scoped=true"
import script from "./z-screen.vue?vue&type=script&lang=js"
export * from "./z-screen.vue?vue&type=script&lang=js"

import "./z-screen.vue?vue&type=style&index=0&id=cb0e7f9e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb0e7f9e"]])

export default __exports__